import * as React from 'react'
const SvgAdjustmentsHorizontalOutlined = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 25"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      fillRule="evenodd"
      d="M8.979 6.759a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m.75-2.25a2.25 2.25 0 0 0-2.122 1.5H4.479a.75.75 0 1 0 0 1.5h3.128a2.25 2.25 0 0 0 4.244 0h9.128a.75.75 0 0 0 0-1.5h-9.128a2.25 2.25 0 0 0-2.122-1.5m6 7.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 0 1 4.244 0h3.128a.75.75 0 0 1 0 1.5h-3.128a2.251 2.251 0 0 1-4.244 0H4.479a.75.75 0 0 1 0-1.5zm-3.878 6a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.25 2.25 0 0 1 4.244 0h9.128a.75.75 0 0 1 0 1.5h-9.128a2.251 2.251 0 0 1-4.244 0H4.479a.75.75 0 0 1 0-1.5z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgAdjustmentsHorizontalOutlined
